// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"268":"2254a5cc","367":"bfa1587d","375":"c51445c3","785":"3f1d8288"}[chunkId] + ".chunk.css";
};